(function () {
  'use strict';

  function isSelected(option) {
    return option.classList.contains('is-selected') || option.classList.contains('is-selected-nt');
  }

  function isUnavailable(option) {
    return option.classList.contains('nt_unavailable');
  }

  function enabledOptions(list) {
    return Array.prototype.filter.call(list.querySelectorAll(':scope > .nt-swatch'), function (option) {
      return !isUnavailable(option);
    });
  }

  function syncPicker(root) {
    (root || document).querySelectorAll('.dropdown_picker_js .nt_lt_fake').forEach(function (picker) {
      var button = picker.querySelector('.header_picker[role="button"]');
      var list = picker.querySelector('.swatches-select[role="listbox"]');
      if (!button || !list) return;

      button.setAttribute('aria-expanded', picker.classList.contains('opended') ? 'true' : 'false');
      list.querySelectorAll(':scope > .nt-swatch').forEach(function (option) {
        option.setAttribute('aria-selected', isSelected(option) ? 'true' : 'false');
        option.setAttribute('aria-disabled', isUnavailable(option) ? 'true' : 'false');
        option.setAttribute('tabindex', '-1');
      });
    });

    (root || document).querySelectorAll('.swatches-select[role="radiogroup"]').forEach(function (group) {
      var options = enabledOptions(group);
      options.forEach(function (option) {
        option.setAttribute('aria-checked', isSelected(option) ? 'true' : 'false');
        option.setAttribute('aria-disabled', 'false');
        option.setAttribute('tabindex', isSelected(option) ? '0' : '-1');
      });
      group.querySelectorAll(':scope > .nt-swatch.nt_unavailable').forEach(function (option) {
        option.setAttribute('aria-disabled', 'true');
        option.setAttribute('tabindex', '-1');
      });
      if (options.length && !group.querySelector(':scope > .nt-swatch[tabindex="0"]')) options[0].setAttribute('tabindex', '0');
    });
  }

  function openList(button, preferLast) {
    var picker = button.closest('.nt_lt_fake');
    var list = picker && picker.querySelector('.swatches-select[role="listbox"]');
    if (!picker || !list) return;
    if (!picker.classList.contains('opended')) button.click();
    window.setTimeout(function () {
      syncPicker(document);
      var options = enabledOptions(list);
      var selected = list.querySelector(':scope > .nt-swatch[aria-selected="true"]');
      var target = selected && !isUnavailable(selected) ? selected : (preferLast ? options[options.length - 1] : options[0]);
      if (target) {
        target.setAttribute('tabindex', '0');
        var focusDeadline = performance.now() + 1000;
        function focusWhenVisible() {
          if (!target.isConnected || document.activeElement !== button || !picker.classList.contains('opended')) return;
          target.focus({ preventScroll: true });
          if (document.activeElement !== target && performance.now() < focusDeadline) {
            window.requestAnimationFrame(focusWhenVisible);
          }
        }
        focusWhenVisible();
      }
    }, 0);
  }

  document.addEventListener('keydown', function (event) {
    var button = event.target.closest('.dropdown_picker_js .header_picker[role="button"]');
    if (button) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openList(button, event.key === 'ArrowUp');
      }
      return;
    }

    var option = event.target.closest('.swatches-select[role="listbox"] > .nt-swatch, .swatches-select[role="radiogroup"] > .nt-swatch');
    if (!option) return;
    var list = option.parentElement;
    var options = enabledOptions(list);
    var index = options.indexOf(option);

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight' || event.key === 'ArrowUp' || event.key === 'ArrowLeft' || event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      var targetIndex;
      if (event.key === 'Home') targetIndex = 0;
      else if (event.key === 'End') targetIndex = options.length - 1;
      else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') targetIndex = (index + 1) % options.length;
      else targetIndex = (index - 1 + options.length) % options.length;
      var target = options[targetIndex];
      if (target) {
        option.setAttribute('tabindex', '-1');
        target.setAttribute('tabindex', '0');
        target.focus();
        if (list.getAttribute('role') === 'radiogroup') target.click();
      }
      return;
    }

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      option.click();
      window.setTimeout(function () {
        syncPicker(document);
        if (list.getAttribute('role') === 'listbox') {
          var listButton = list.closest('.nt_lt_fake').querySelector('.header_picker[role="button"]');
          if (listButton) listButton.focus();
        }
      }, 0);
      return;
    }

    if (event.key === 'Escape' && list.getAttribute('role') === 'listbox') {
      event.preventDefault();
      var picker = list.closest('.nt_lt_fake');
      var closeButton = picker.querySelector('.header_picker[role="button"]');
      picker.classList.remove('opended');
      syncPicker(document);
      if (closeButton) closeButton.focus();
    }
  });

  document.addEventListener('click', function () {
    window.setTimeout(function () { syncPicker(document); }, 0);
  });

  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).on('variant:change', function (_event, variant) {
      document.querySelectorAll('[data-sale-policy-notice]').forEach(function (notice) {
        notice.hidden = !(variant && variant.compare_at_price > variant.price);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncPicker(document); });
  else syncPicker(document);
}());

(() => {
  const selector = '.nt_add_w a[data-id]';
  const suffixes = new WeakMap();
  function sync(link) {
    const text = link.querySelector('.tt_txt')?.textContent.trim();
    if (!text) return;
    if (!suffixes.has(link)) {
      const label = link.getAttribute('aria-label') || '';
      const separator = label.indexOf(': ');
      suffixes.set(link, separator < 0 ? '' : label.slice(separator));
    }
    const label = text + suffixes.get(link);
    if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
  }
  function scan(node) {
    const element = node.nodeType === 1 ? node : node.parentElement;
    if (!element) return;
    const link = element.closest(selector);
    if (link) sync(link);
    element.querySelectorAll(selector).forEach(sync);
  }
  function start() {
    scan(document.body);
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'childList') {
          if (record.target.closest?.(selector)) scan(record.target);
          record.addedNodes.forEach(scan);
        } else if (record.type === 'characterData') scan(record.target);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
